import Vue from 'vue';
import store from '@/store/index';
import EventBus from '@/plugins/eventBus';

export default {
  SET_SIDEBAR(state, payload) {
    state.sidebar = payload;
  },
  set_tickets(state, payload) {
    state.tickets = [...payload];
  },
  setLoginError(state, payload) {
    state.loginError = payload;
  },
  setGameplayToken(state, payload) {
    state.gameplayToken = payload;
  },
  setPrivateRoomsList(state, payload) {
    state.privateRoomsList = payload;
  },
  setFriendList(state, payload) {
    state.userFriends = payload;
  },
  setAllUserFriends(state, payload) {
    state.allUserFriends = payload;
  },
  setAcceptedFriendsList(state, payload) {
    state.userFriendsAccepted = payload;
  },
  setRejectedFriendList(state, payload) {
    state.userFriendsRejected = payload;
  },
  setBlockedFriendList(state, payload) {
    state.userFriendsBlocked = payload;
  },
  setSentFriendList(state, payload) {
    state.userFriendsSent = payload;
  },
  setWalletDialog(state, payload) {
    state.walletDialog = payload;
  },
  setReceivedFriendList(state, payload) {
    state.userFriendsReceived = payload;
  },
  setError(state, payload) {
    state.error = payload;
  },
  setIsOlympusAvailable(state, payload) {
    state.isOlympusAvailable = payload;
  },
  setIsMultiPlinkoLimitedAvailable(state, payload) {
    state.isMultiPlinkoLimitedAvailable = payload;
  },
  setIsRollOrHoldLimitedAvailable(state, payload) {
    state.isRollOrHoldLimitedAvailable = payload;
  },
  setIsEscapeTheCircleLimitedAvailable(state, payload) {
    state.isEscapeTheCircleLimitedAvailable = payload;
  },
  setSingleGameData(state, payload) {
    state.singlegamedata = payload;
  },
  setCurrentUserId(state, payload) {
    state.currentUserID = payload;
  },
  clearError(state) {
    state.error = null;
  },
  clearLoginResponse(state) {
    state.loginError = null;
  },
  setSystemEvents(state, payload) {
    state.systemevents = payload;
  },

  setLoadedSites(state, payload) {
    state.loadedSites = payload;
    state.sites = payload;
  },
  setUserProfile(state, payload) {
    state.userprofile = payload;
  },
  setLoadedProfiles(state, payload) {
    state.siteprofiles = payload;
  },
  setLoadedUserGameplay(state, payload) {
    state.allusergameplay = payload;
  },
  setPaymentCred(state, payload) {
    state.paymentCredentials = payload;
  },
  setGamesList(state, payload) {
    state.gamelist = payload;
  },
  setFullGameData(state, payload) {
    state.fullgamedata = payload;
  },
  setTopWins(state, payload) {
    state.topwins = payload;
  },
  setTopLoss(state, payload) {
    state.toploss = payload;
  },
  setTopBets(state, payload) {
    state.topbets = payload;
  },
  setUserGameData(state, payload) {
    state.usergamedata = payload;
  },
  setTokenMap(state, payload) {
    state.tokenmap = payload;
  },
  setPrivateRoomURL(state, payload) {
    state.privateRoomURL = payload;
  },
  setReferrals(state, payload) {
    state.allReferrals = payload;
  },
  setPossibleFriends(state, payload) {
    state.possibleFriends = payload;
  },
  setUserSuspended(state, payload) {
    state.userSuspended = payload;
  },
  setIsManualSignIn(state, payload) {
    state.isManualSignIn = payload;
  },

  setUser(state, payload) {
    if (payload) {
      localStorage.setItem('user', JSON.stringify(payload));

      if (payload.suspended) {
        state.userSuspended = payload.suspended;
        EventBus.emit('user-suspended');
      }
    } else {
      localStorage.removeItem('user');
      localStorage.removeItem('session');

      state.firebaseToken = null;
      state.userSuspended = false;
      state.isLoggedIn = false;
    }

    state.user = payload;
    state.userCheckCompleted = true;
  },
  setUserGroups(state, payload) {
    state.usergroups = payload;
  },
  setUserInstitutions(state, payload) {
    state.userinstitutions = payload;
  },
  setCheckFrontData(state, payload) {
    state.checkResponseData = payload;
  },
  setLoadedUserProfiles(state, payload) {
    state.userprofiles = [...payload];
  },
  setUserpurchases(state, payload) {
    state.userpurchases = payload;
  },
  setUserwithdraws(state, payload) {
    state.userwithdraws = payload;
  },
  setLoadedWalletusers(state, payload) {
    state.loadedwalletusers = payload;
  },
  setPromotionDetails(state, payload) {
    state.promotionDetails = payload;
  },
  setSignuptemplate(state, payload) {
    state.signuptemplate = payload;
  },
  setInactivetemplate(state, payload) {
    state.inactivetemplate = payload;
  },
  setPlayerlosstemplate(state, payload) {
    state.playerlosstemplate = payload;
  },
  setPromolossamount(state, payload) {
    state.promolossamount = payload;
  },
  setPlayerbettemplate(state, payload) {
    state.playerbettemplate = payload;
  },
  setPromodaysinactive(state, payload) {
    state.promodaysinactive = payload;
  },
  setDeposittemplate(state, payload) {
    state.deposittemplate = payload;
  },
  setWithdrawaltemplate(state, payload) {
    state.withdrawaltemplate = payload;
  },
  withdrawalReservations(state, payload) {
    state.withdrawalReservations = payload;
  },
  setUserWithdrawals(state, payload) {
    state.userWithdrawals = payload;
  },
  setUserTotalWithdrawalRequests(state, payload) {
    state.totalUserWithdrawalRequests = payload;
  },
  setPurchasetemplate(state, payload) {
    state.purchasetemplate = payload;
  },
  setLoadedAlerts(state, payload) {
    state.alerts = payload;
  },
  appendLoadedAlerts(state, payload) {
    let addNew = true;
    for (let value in state.alerts) {
      if (state.alerts[value].key === payload.key) {
        Vue.set(state.alerts, value, payload);
        addNew = false;
      }
    }

    if (addNew) {
      state.alerts.push(payload);
    }
  },
  appendUserBlockedFrom(state, payload) {
    let friend = {
      ...payload,
      image: 'Profile_Pic.png',
      key: payload.friendId,
    };
    let addNew = true;

    for (let value in state.userBlockedFrom) {
      if (state.userBlockedFrom[value].friendId === friend.friendId) {
        state.userBlockedFrom[value] = friend;
        addNew = false;
      }
    }

    if (addNew) {
      state.userBlockedFrom.push(friend);
    }
  },

  removeFromListOfUserBlockedFrom(state, payload) {
    for (let value in state.userBlockedFrom) {
      if (state.userBlockedFrom[value].friendId === payload.friendId) {
        state.userBlockedFrom.splice(value, 1);
      }
    }
  },

  updateFriendOnlineStatus(state, { displayName, isOnline }) {
    const friend = state.allUserFriends.find((f) => f.displayName === displayName);
    if (friend) {
      friend.online = isOnline;
    }
  },

  updateChallengeOnlineStatus(state, { displayName, isOnline }) {
    state.challenges = state.challenges.map((challenge) => {
      if (challenge.displayName === displayName) {
        challenge.online = isOnline;
      }
      return challenge;
    });
  },

  updateAlertOnlineStatus(state, { displayName, isOnline }) {
    state.alerts = state.alerts.map((alert) => {
      if (alert.displayName === displayName) {
        alert.online = isOnline;
      }
      return alert;
    });
  },

  updateLastPlayedWithOnlineStatus(state, { displayName, isOnline }) {
    const player = state.lastPlayedWith.find((p) => p.displayName === displayName);
    if (player) {
      player.online = isOnline;
    }
  },

  appendLastPlayedWith(state, payload) {
    let addNew = true;

    for (let value in state.lastPlayedWith) {
      if (state.lastPlayedWith[value].displayName === payload.displayName) {
        state.lastPlayedWith[value] = payload;
        addNew = false;
      }
    }

    if (addNew) {
      state.lastPlayedWith.push(payload);
    }
  },

  appendOnlineUsers(state, payload) {
    state.onlineUsersFromList = [...payload];
  },

  removeOnlineUser(state, userName) {
    state.onlineUsersFromList = state.onlineUsersFromList.filter((user) => user.displayName !== userName);
  },

  removeFromListOfLastPlayedWith(state, payload) {
    for (let value in state.lastPlayedWith) {
      if (state.lastPlayedWith[value].displayName === payload.displayName) {
        state.lastPlayedWith[value].databaseRef?.off();
        state.lastPlayedWith.splice(value, 1);
      }
    }
  },

  appendListOfFriends(state, payload) {
    let friend = {
      ...payload,
      image: 'Profile_Pic.png',
      key: payload.friendId,
    };
    let addNew = true;
    for (let value in state.allUserFriends) {
      if (state.allUserFriends[value].friendId === friend.friendId) {
        state.allUserFriends[value] = friend;
        addNew = false;
      }
    }

    if (addNew) {
      state.allUserFriends.push(friend);
    }

    let tempFriends = state.allUserFriends;

    state.userFriendsAccepted = tempFriends.filter(function (friend) {
      return friend.status === 'friend';
    });

    state.userFriendsRejected = tempFriends.filter(function (friend) {
      return friend.status === 'rejected';
    });
    state.userFriendsBlocked = tempFriends.filter(function (friend) {
      return friend.status === 'blocked';
    });
    state.userFriendsSent = tempFriends.filter(function (friend) {
      return friend.status === 'sent';
    });
    state.userFriendsReceived = tempFriends.filter(function (friend) {
      return friend.status === 'received';
    });
  },

  removeFromListOfFriends(state, payload) {
    for (let value in state.allUserFriends) {
      if (state.allUserFriends[value].friendId === payload.friendId) {
        state.allUserFriends[value].databaseRef?.off();
        state.allUserFriends.splice(value, 1);
      }
    }

    let tempFriends = state.allUserFriends;

    state.userFriendsAccepted = tempFriends.filter(function (friend) {
      return friend.status === 'friend';
    });

    state.userFriendsRejected = tempFriends.filter(function (friend) {
      return friend.status === 'rejected';
    });
    state.userFriendsBlocked = tempFriends.filter(function (friend) {
      return friend.status === 'blocked';
    });
    state.userFriendsSent = tempFriends.filter(function (friend) {
      return friend.status === 'sent';
    });
    state.userFriendsReceived = tempFriends.filter(function (friend) {
      return friend.status === 'received';
    });
  },
  setListOfActiveGames(state, payload) {
    state.activeGames = payload;
  },
  appendListOfActiveGames(state, payload) {
    for (let value in state.activeGames) {
      if (state.activeGames[value].key === payload.key) {
        Vue.set(state.activeGames, value, payload);
        return;
      }
    }
    state.activeGames.push(payload);
  },
  removeFromListOfActiveGames(state, payload) {
    for (let value in state.activeGames) {
      if (state.activeGames[value].key === payload.key) {
        state.activeGames.splice(value, 1);
      }
    }
  },
  setcurrentchallenge(state, payload) {
    state.acceptedchallenge = payload;
  },
  appendLoadedChallenges(state, payload) {
    for (let value in state.challenges) {
      if (state.challenges[value].key === payload.key) {
        Vue.set(state.challenges, value, payload);
        return;
      }
    }
    state.challenges.push(payload);
  },
  appendUnseenChallenges(state, payload) {
    store.dispatch('showNotificationTooltip', payload.message);

    for (let value in state.unseenChallenges) {
      if (state.unseenChallenges[value].key === payload.key) {
        Vue.set(state.unseenChallenges, value, payload);
        return;
      }
    }

    state.unseenChallenges.push(payload);
  },
  removeLoadedPrivateRooms(state, payload) {
    for (let value in state.privateRooms) {
      if (state.privateRooms[value].privateRoomId === payload.privateRoomId) {
        state.privateRooms.splice(value, 1);
      }
    }
  },
  setNewNotification(state, payload) {
    state.newNotification = payload;
  },
  appendLoadedPrivateRooms(state, payload) {
    for (let value in state.privateRooms) {
      if (state.privateRooms[value].privateRoomId === payload.privateRoomId) {
        state.privateRooms.splice(value, 1);
      }
    }
    state.privateRooms.push(payload);
  },
  appendUnityRooms(state, payload) {
    // state.privateRooms = [];

    const mapInvitedPlayers = (invitedArray) => {
      let returnValue = [];
      invitedArray.forEach((player) => {
        returnValue[player] = {
          id: player,
          displayName: payload.allRoomsDisplayNames.get(player),
          inviteAccepted: true,
        };
      });
      return returnValue;
    };

    const determineInvitedPlayers = (roomId) => {
      const room = payload.allInvitedRoomsFullData.find((room) => room?.id === roomId);
      if (room && room.invited && room.invited.length > 0) {
        return mapInvitedPlayers(room.invited);
      }
      return {};
    };

    if (payload.responseData.privateRooms.length > 0) {
      const combinedPrivateRooms = [
        ...payload.responseData.privateRooms.map((room) => ({
          ...room,
          gameId: payload.responseData.gameId,
          hostDisplayName: payload.hostDisplayName,
          hostId: payload.responseData.platformId,
        })),
      ];
      combinedPrivateRooms.forEach((room) => {
        const existingRoomIndex = state.privateRooms.findIndex(
          (existingRoom) => existingRoom.privateRoomId === room.id,
        );

        if (existingRoomIndex !== -1) {
          state.privateRooms[existingRoomIndex] = {
            ...state.privateRooms[existingRoomIndex],
            active: true,
            bankId: room.bankId,
            buyIn: room.buyIn,
            customRoomId: room.customRoomId || null,
            dateCreated: room.created,
            hostDisplayName: room.hostDisplayName,
            hostId: room.hostId,
            playersInvited: room.invited && room.invited.length === 0 ? {} : mapInvitedPlayers(room.invited),
            gameId: room.gameId,
          };
        } else {
          state.privateRooms.push({
            active: true,
            bankId: room.bankId,
            buyIn: room.buyIn,
            customRoomId: room.customRoomId || null,
            dateCreated: room.created,
            hostDisplayName: room.hostDisplayName,
            hostId: room.hostId,
            playersInvited: room.invited && room.invited.length === 0 ? {} : mapInvitedPlayers(room.invited),
            privateRoomId: room.id,
            gameId: room.gameId,
          });
        }
      });
    }

    if (payload.responseData.closedRooms.length > 0) {
      const combinedClosedRooms = [
        ...payload.responseData.closedRooms.map((room) => ({
          ...room,
          gameId: payload.responseData.gameId,
          hostDisplayName: payload.hostDisplayName,
          hostId: payload.responseData.platformId,
        })),
      ];

      if (combinedClosedRooms.length > 0) {
        combinedClosedRooms.forEach((room) => {
          const existingRoomIndex = state.privateRooms.findIndex(
            (existingRoom) => existingRoom.privateRoomId === room.id,
          );

          if (existingRoomIndex !== -1) {
            state.privateRooms[existingRoomIndex] = {
              ...state.privateRooms[existingRoomIndex],
              active: false,
              bankId: room.bankId,
              buyIn: room.buyIn,
              customRoomId: room.customRoomId || null,
              dateCreated: room.created,
              hostDisplayName: room.hostDisplayName,
              hostId: room.hostId,
              gameId: room.gameId,
            };
          } else {
            state.privateRooms.push({
              active: false,
              bankId: room.bankId,
              buyIn: room.buyIn,
              customRoomId: room.customRoomId || null,
              dateCreated: room.created,
              hostDisplayName: room.hostDisplayName,
              hostId: room.hostId,
              privateRoomId: room.id,
              gameId: room.gameId,
            });
          }
        });
      }
    }

    if (payload.responseData.invitedRooms.length > 0) {
      const combinedInvitedRooms = [
        ...payload.responseData.invitedRooms.map((room) => ({ ...room, gameId: payload.responseData.gameId })),
      ];

      if (combinedInvitedRooms.length > 0) {
        combinedInvitedRooms.forEach((room) => {
          const existingRoomIndex = state.privateRooms.findIndex(
            (existingRoom) => existingRoom.privateRoomId === room.roomId,
          );

          if (existingRoomIndex !== -1) {
            state.privateRooms[existingRoomIndex] = {
              ...state.privateRooms[existingRoomIndex],
              active: !room.isClosed ?? false,
              bankId: room.bankId,
              buyIn: room.buyIn,
              customRoomId: room.customRoomId || null,
              dateCreated: room.lastEntered,
              hostDisplayName: payload.allRoomsDisplayNames.get(room.hostPlatformId),
              hostId: room.hostPlatformId,
              playersInvited: determineInvitedPlayers(room.roomId),
              gameId: room.gameId,
            };
          } else {
            state.privateRooms.push({
              active: !room.isClosed ?? false,
              bankId: room.bankId,
              buyIn: room.buyIn,
              customRoomId: room.customRoomId || null,
              dateCreated: room.lastEntered,
              hostDisplayName: payload.allRoomsDisplayNames.get(room.hostPlatformId),
              hostId: room.hostPlatformId,
              playersInvited: determineInvitedPlayers(room.roomId),
              privateRoomId: room.roomId,
              gameId: room.gameId,
            });
          }
        });
      }
    }
  },
  removeUnseenChallenge(state, payload) {
    for (const challengeIndex in state.unseenChallenges) {
      if (state.unseenChallenges[challengeIndex].roomId === payload.roomId) {
        state.unseenChallenges.splice(challengeIndex, 1);
        break;
      }
    }
  },
  setLoadedChallenges(state, payload) {
    state.challenges = payload;
  },
  setUserDeposits(state, payload) {
    state.userdeposits = payload;
  },
  setPostDeposits(state, payload) {
    state.postdeposits = payload;
  },

  setLoadedTokenProfiles(state, payload) {
    state.tokenprofiles = payload;
  },
  setLoadedTokenSales(state, payload) {
    state.tokensales = payload;
  },
  setLoadedGameRounds(state, payload) {
    state.gamerounds = payload;
  },
  setLoadedBillingProfiles(state, payload) {
    state.billingprofiles = payload;
  },
  setLoading(state, payload) {
    state.isloading = payload;
  },
  setReferralLink(state, payload) {
    state.referralLink = payload;
  },
  setDisplayname(state, payload) {
    state.userdisplay = payload;
  },
  setDisplaybio(state, payload) {
    state.userbio = payload;
  },
  setDisplaylevel(state, payload) {
    state.userlevel = payload;
  },
  setDisplaypoints(state, payload) {
    state.userpoints = payload;
  },
  setDepositMethods(state, payload) {
    state.depositMethods = payload;
  },
  setRequestInvoice(state, payload) {
    state.invoiceData = payload;
  },
  setOrderStatus(state, payload) {
    state.orderStatus = payload;
  },
  setRequestWithdrawal(state, payload) {
    state.withdrawalData = payload;
  },

  setUserTotalBalance(state) {
    const balance = {
      MMC:
        (parseInt(state.depositBalance?.balance?.MMC, 10) || 0) +
        (parseInt(state.withdrawableBalance?.balance?.MMC, 10) || 0),
      MQC:
        (parseInt(state.depositBalance?.balance?.MQC, 10) || 0) +
        (parseInt(state.withdrawableBalance?.balance?.MQC, 10) || 0),
    };

    state.totalBalance = { balance };
  },
  setUserDepositBalance(state, payload) {
    if (state.depositBalance?.balance && payload.balance) {
      state.totalBalance.balance.MQC -= parseInt(state.depositBalance.balance.MQC, 10);
      state.totalBalance.balance.MMC -= parseInt(state.depositBalance.balance.MMC, 10);
    }

    state.depositBalance = payload;

    this.commit('setUserTotalBalance');
  },
  // setUserBonusBalance(state, payload) {
  //   state.bonusBalance = payload;
  // },
  setUserWithdrawableBalance(state, payload) {
    if (state.withdrawableBalance?.balance && payload.balance) {
      state.totalBalance.balance.MQC -= parseInt(state.withdrawableBalance.balance.MQC, 10);
      state.totalBalance.balance.MMC -= parseInt(state.withdrawableBalance.balance.MMC, 10);
    }

    state.withdrawableBalance = payload;
    this.commit('setUserTotalBalance');
  },

  setUserReferralRewardData(state, payload) {
    state.userReferralRewardsData.balance = payload.balance;
    state.userReferralRewardsData.count = payload.count;
  },
  setGlobalAffiliateConfig(state, payload) {
    state.globalAffiliateConfig = payload;
  },
  setGlobalConfig(state, payload) {
    state.globalConfig = payload;
  },
  setPlayerMode(state, payload) {
    state.playermode = payload;
    localStorage.setItem('currency', payload);
  },
  setIsMobileResolution(state, payload) {
    state.isMobileResolution = payload;
  },
  setRoomsPlayerNumber(state, roomsPlayerNumber) {
    state.roomsPlayerNumber = roomsPlayerNumber;
  },
  setTransHistory(state, payload) {
    state.transHistory = payload;
  },
  // setBonusHistory(state, payload) {
  //   state.bonusHistory = payload;
  // },
  setCountryInfo(state, payload) {
    state.countryInfo = payload;
  },
  setPackages(state, payload) {
    state.packages = payload;
  },
  setProfile(state, payload) {
    state.mqtechProfile = payload;
  },
  setPlayerInfo(state, payload) {
    state.playerInfo = payload;
  },
  setRecentlyPlayed(state, payload) {
    state.recentPlayed = payload;
  },
  setUserDocs(state, payload) {
    state.userDocs = payload;
  },
  setGameHistory(state, payload) {
    state.gameHistory = payload;
  },
  setPrivateRoomID(state, payload) {
    state.privateRoomID = payload;
  },
  setHomeUrl(state, payload) {
    state.homeUrl = payload;
  },
  setLastPlayedWith(state, payload) {
    state.lastPlayedWith = payload;
  },
  setGameWindow(state, payload) {
    state.gameWindow = payload;
  },

  setSumsubAccessToken(state, payload) {
    state.sumsubAccessToken = payload;
  },

  appendReferrals(state, payload) {
    for (let value in state.allReferrals) {
      if (state.allReferrals[value].displayName === payload.displayName) {
        state.allReferrals.splice(value, 1);
      }
    }
    state.allReferrals.push(payload);
  },
  removeReferral(state, payload) {
    for (const referralIndex in state.allReferrals) {
      if (state.allReferrals[referralIndex].displayName === payload.displayName) {
        state.allReferrals.splice(referralIndex, 1);
        break;
      }
    }
  },
  setUserRakeback(state, payload) {
    state.rakeback = payload;
  },
  // setAvailableBonuses(state, payload) {
  //   state.availableBonuses = payload;
  // },
  // setAllActiveBonuses(state, payload) {
  //   state.allActiveBonuses = payload;
  // },
  // setUnclaimedBonuses(state, payload) {
  //   state.unclaimedBonuses = payload;
  // },
  setUserBoughtPackages(state, payload) {
    state.boughtPackages = payload || {};
  },

  SET_FIREBASE_TOKEN(state, data) {
    state.firebaseToken = data.token;
    state.firebaseTokenExpirationTime = data.expirationTime;
  },

  SET_PACKAGES_PENDING(state, value) {
    state.packagesPending = value;
  },

  SET_PENDING_FLAG(state, [key, value]) {
    Vue.set(state.pendingFlags, key, value);
  },

  SET_SOCIAL_SIGN_UP(state, value) {
    state.isSocialSignUp = value;
  },

  SET_TOTAL_NOTIFICATION_AMOUNT(state, value) {
    state.totalNotificationAmount = value;
  },

  SET_CASHIER_CURRENCIES(state, value) {
    state.cashierCurrencies = value;
  },

  SET_USER_CHECK_COMPLETED(state, value) {
    state.userCheckCompleted = value;
  },

  SET_LOGGED_IN(state, value) {
    state.isLoggedIn = value;
  },

  SET_IS_EMAIL_VERIFICATION_TAB(state) {
    state.isEmailVerificationTab = true;
  },
};
